import React from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Routers from './routes/index';
import { AuthProvider } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import "../src/styles/custom.css"
import { ThemeProvider } from './contexts/ThemeContext';
function App() {
    return (
        <AuthProvider>
            <ThemeProvider>
                <BrowserRouter>
                    <Routers />
                    <ToastContainer autoClose={1500} />
                </BrowserRouter>
            </ThemeProvider>
        </AuthProvider>
    );
}

export default App;
